import { useLocation, Link } from "react-router-dom";
import Fuse from "fuse.js";
import { FileText, ArrowRightCircle } from "lucide-react"; // icons
import searchData from "./searchData.js";
import "./SearchResults.css";

const SearchResults = () => {
  const query = new URLSearchParams(useLocation().search).get("q") || "";

  const fuse = new Fuse(searchData, {
    keys: ["title", "content"],
    threshold: 0.3,
  });

  const results = query ? fuse.search(query) : [];

  return (
    <div className="results-page">
      <div className="results-inner">
        <div className="results-header">
          <h2 className="results-title">Results for “{query}”</h2>
          <div className="results-divider" />
        </div>

        {results.length === 0 ? (
          <p className="no-results">No results found. Try another keyword!</p>
        ) : (
          <div className="results-list">
            {results.map(({ item }, i) => (
              <div className="result-item" key={i}>
                <div className="result-header">
                  <FileText className="result-icon" />
                  <Link to={item.path} className="result-heading">
                    {item.title}
                  </Link>
                </div>

                <ul className="result-bullets">
                  {item.content
                    .split("\n")
                    .filter(line => line.trim() !== "")
                    .map((point, idx) => (
                      <li key={idx}>
                        <ArrowRightCircle className="bullet-icon" />
                        <span>{point.trim()}</span>
                      </li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResults;
